import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';

const SignUpSellerModal = (props: { isOpen: boolean; onClose: (success: boolean) => void }) => {
    const { isOpen, onClose } = props;
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [form, setForm] = useState({
        email: '',
        name: '',
        surname: '',
        company: '',
        phone: '',
    });

    if (!isOpen) return null;

    const handleChange = (e: any) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
        setError('');
    };

    const handleSubmit = () => {
        if (!form.email) {
            setError('Veuillez renseigner votre email.');
            return;
        }
        const token = localStorage.getItem('token');
        axios
            .put(`${CONFIG.apiUrl}/user`, form, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then(() => {
                setSuccess(true);
            })
            .catch((err) => {
                setError(err?.response?.data?.error || 'Une erreur est survenue.');
            });
    };

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-gray-900/70 backdrop-blur-md">
            <div className="relative z-[1002] w-full max-w-[420px] p-4">
                <Card extra="px-[30px] pt-[35px] pb-[40px] w-full flex flex-col !z-[1004] border shadow-2xl">
                    {success ? (
                        <div className="text-center py-6">
                            <div className="text-4xl mb-4">✅</div>
                            <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-2">
                                Compte créé !
                            </h3>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
                                Un email vous a été envoyé à <strong>{form.email}</strong> pour définir votre mot de passe.
                            </p>
                            <button
                                className="w-full rounded-xl bg-leadrs py-3 text-base font-medium text-white transition duration-200 hover:bg-leadrs/90"
                                onClick={() => onClose(true)}
                            >
                                Continuer
                            </button>
                        </div>
                    ) : (
                        <>
                            <h3 className="mb-2 text-xl font-bold text-navy-700 dark:text-white text-center">
                                Créer mon compte vendeur
                            </h3>
                            <p className="mb-5 text-center text-sm text-gray-600">
                                Renseignez vos informations pour activer votre compte.
                            </p>

                            {error && (
                                <p className="mb-3 text-center text-sm text-red-500">{error}</p>
                            )}

                            <InputField
                                variant="auth"
                                extra="mb-3 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                                label="Email*"
                                placeholder="contact@monsiteweb.fr"
                                id="email"
                                type="email"
                                onChange={handleChange}
                            />

                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <InputField
                                    variant="auth"
                                    extra="[&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                                    label="Prénom"
                                    placeholder="Jean"
                                    id="name"
                                    type="text"
                                    onChange={handleChange}
                                />
                                <InputField
                                    variant="auth"
                                    extra="[&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                                    label="Nom"
                                    placeholder="Dupont"
                                    id="surname"
                                    type="text"
                                    onChange={handleChange}
                                />
                            </div>

                            <InputField
                                variant="auth"
                                extra="mb-3 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                                label="Entreprise"
                                placeholder="Ma Société SAS"
                                id="company"
                                type="text"
                                onChange={handleChange}
                            />

                            <InputField
                                variant="auth"
                                extra="mb-4 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                                label="Téléphone"
                                placeholder="+33..."
                                id="phone"
                                type="phone"
                                onChange={handleChange}
                            />

                            <button
                                className="w-full rounded-xl bg-leadrs py-3 text-base font-medium text-white transition duration-200 hover:bg-leadrs/90"
                                onClick={handleSubmit}
                            >
                                Activer mon compte
                            </button>

                            <div className="mt-3 text-center">
                                <span className="text-sm text-navy-700 dark:text-gray-500">
                                    Déjà inscrit ?{' '}
                                </span>
                                <a
                                    href="/auth/sign-in/"
                                    className="text-sm font-medium text-leadrs hover:text-brand-600"
                                >
                                    Se connecter
                                </a>
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default SignUpSellerModal;
